<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class CruisesPageMixin extends Vue {
        async loadRuntimeData() {
            if (cruisesRuntimeStore.departureCity?.id !== this.searchRequest.departureCityId) {
                await cruisesRuntimeStore.loadDepartureCity(this.searchRequest.departureCityId)
            }
            if (cruisesRuntimeStore.destinationCity.id !== this.searchRequest.destinationCityId) {
                await cruisesRuntimeStore.loadDestinationCity(this.searchRequest.destinationCityId)
            }
        }
    }

    export default CruisesPageMixin
</script>
